// extracted by mini-css-extract-plugin
export default {"root":"K4dTkX"};